import { Injectable } from '@angular/core';
import { DataService } from "./../../../../app/core/services/data.service";
import { Observable,of} from 'rxjs';
import { SupplierAdvanceSearchResponse } from '../models/supplier-advance-search.model';
import {
  InstantPurchaseAcceptOrderRequest,
  InstantPurchaseAcceptOrderResponse,
  InstantPurchaseApiResponse,
  InstantPurchaseCounterOfferRequest,
  InstantPurchaseCounterOfferResponse,
  InstantPurchaseGetCounterOfferRequest,
  InstantPurchaseGetCounterOfferResponse,
  InstantPurchaseRfqFeedbackCheckRequest,
  InstantPurchaseRfqFeedbackCheckResponse,
  InstantPurchaseRfqFeedbackSaveRequest,
  InstantPurchaseRfqFeedbackSaveResponse,
} from '../instant-purchase/instant-purchase.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { SupplierDynamicTilesIntentScoringResponse } from '../../../core/models/supplierDynamicTilesIntentModel';
import {
  SupplierDashboardTileFeedResponse,
  SupplierDashboardTileHistoryResponse,
  SupplierDashboardTileCtaClickRequest
} from '../../../core/models/userPersonalizationTilesModel';
@Injectable()
export class SupplierV2Service {

  constructor(
    private dataService: DataService,
    private http: HttpClient
  ) { }

  loadAllActiveRFQForSupplier(): Observable<SupplierAdvanceSearchResponse> {
    let data = {
      "supplierCompanyId": AppStorageUtil.getCommpanyId(),
      "savedSearchId": 0,
      "contactId": AppStorageUtil.getLoogedUserId()
    };
    return this.dataService.add("AdvanceSearch", data) as Observable<SupplierAdvanceSearchResponse>;
  }

  /** Network RFQ list — POST api/AdvanceSearch/NetworkRfqs (same body/auth as AdvanceSearch). */
  loadNetworkRfqsForSupplier(): Observable<SupplierAdvanceSearchResponse> {
    const data = {
      supplierCompanyId: AppStorageUtil.getCommpanyId(),
      savedSearchId: 0,
      contactId: AppStorageUtil.getLoogedUserId()
    };
    return this.dataService.add("AdvanceSearch/NetworkRfqs", data) as Observable<SupplierAdvanceSearchResponse>;
  }
  updateSupplierCapability(iProcessesViewModel: any): Observable<any> {
    return this.dataService.UpdateWithoutId('Supplier/UpdateCapabilities', iProcessesViewModel);
  }
  getSupplierParentProcesses(companyId: number, isRfqSearchType: boolean = true
  ): Observable<any[]> {
    const url =
      "Supplier/GetSupplierParentProcesses?supplierCompanyId=" + companyId + "&isRfqSearchType=" + isRfqSearchType;
    return this.dataService.getAll(url);
  }
  getParentMaterial(): Observable<any[]> {
    return this.dataService.getAll("Master/GetMaterialsData");
  }
  getPostProdProcesses(): Observable<any[]> {
    return this.dataService.getAll("Master/GetPostProductionProcessesData");
  }
  getMyRfqSavedSearchByContact(contactId: number): Observable<any> {
    return this.dataService.getAll("SavedSearch?contactId=" + contactId);
  }
  isValidPostalCode(contactId: number): Observable<any> {
    return this.dataService.getAll("IsValidPostalCode?contactId=" + contactId);
  }
  setSavedSearchDefaultFilter(savedSearchDefaultFilterViewModel: any): Observable<any> {
    return this.dataService.add("SavedSearchDefaultFilter", savedSearchDefaultFilterViewModel);
  }
  setMyRfqSavedSearchFilter(savedSearchFilterModel: any): Observable<any> {
    return this.dataService.add("SavedSearch", savedSearchFilterModel);
  }
  getMyRfqSavedSearchDetail(savedSearchId: number): Observable<any> {
    return this.dataService.getAll("SavedSearchFilter?savedSearchId=" + savedSearchId);
  }
  getSupplierChildProcesses(supplierChildProcessViewModel: any): Observable<any> {
    return this.dataService.add("Supplier/GetSupplierChildProcesses", supplierChildProcessViewModel);
  }
  rfqLikeOrDislike(data: any): Observable < any > {
    return this.dataService.add('RFQ/SetSupplierRFQLike', data);
  }
  getSupplierPackageInfo(contactId: number, companyId: number): Observable < any > {
    return this.dataService.getAll('GrowthPackage/GetSupplierPackageInfo?contactId=' + contactId+'&companyId='+companyId);
  }
  setGrowthPackageUnlockRFQsInfo(data): Observable < any > {
    return this.dataService.add('GrowthPackage/SetGrowthPackageUnlockRFQsInfo', data);
  }
  deleteSavedSearchDetails(id: any): Observable<any> {
    return this.dataService.add("RFQ/DeleteSavedSearchDetails?SavedSearchId=" + id,"");
  }

  getSupplierRfqInsightQuote(rfqId): Observable <any>{
    return this.dataService.getAll("supplier/GetSupplierRFQInsights?rfqId=" + rfqId + "&contactId=" + AppStorageUtil.getLoogedUserId());
  }

  getBuyerDetailInsight(contactId): Observable <any>{
    return this.dataService.getAll("buyer/GetBuyerInsights?contactId=" + contactId);
  }

  getDistanceBetweenContact(buyerContactId): Observable <any>{
    if (!buyerContactId) {
      // Return an empty observable if buyerContactId is missing
      return of(null);
    }
  return this.dataService.getAll("contact/GetDistanceBetweenContacts?supplierContactId=" + AppStorageUtil.getLoogedUserId() + "&buyerContactId=" + buyerContactId);
  }

  getTokenInfo(companyId: number): Observable < any > {
    return this.dataService.getAll('supplier/GetTokenEntitlements?companyId=' + companyId+ "&mode=rfq");
  }

  setRFQUnlock(data): Observable < any > {
    return this.dataService.add('supplier/UnlockRfq', data);
  }
  getCapabilities(companyId: number, isRfqSearchType: boolean): Observable <any> {
       return this.dataService.getAll( 'Supplier/GetSuppliersProcesses?CompanyId=' + companyId + '&isRfqSearchType=' + isRfqSearchType, '');
  }

  getInstantPurchaseList(): Observable<InstantPurchaseApiResponse> {
    const data = {
      contactId: AppStorageUtil.getLoogedUserId(),
      supplierCompanyId: parseInt(AppStorageUtil.getCommpanyId(), 10),
    };
    return this.dataService.add<InstantPurchaseApiResponse>('InstantPurchase', data);
  }

  getAllProcesses(): Observable<unknown> {
    return this.dataService.getAll("Master/GetAllProcesses");
  }

  getMaterialsByProcessIds(processIds: number[]): Observable<unknown> {
    return this.dataService.add("Master/GetMaterialsDataByProcessIds", {
      processIds,
    });
  }

  getMaterialGrades(materialId: number): Observable<unknown> {
    return this.dataService.add("WidgetRfq/GetMaterialGrades", {
      material_id: materialId,
      materialId,
    });
  }

  getPostProductionProcessesByProcessIds(processIds: number[]): Observable<unknown> {
    return this.dataService.add("Master/GetPostProductionProcessesDataByProcessIds", {
      processIds,
    });
  }

  acceptInstantPurchaseOrder(
    payload: InstantPurchaseAcceptOrderRequest
  ): Observable<InstantPurchaseAcceptOrderResponse> {
    return this.dataService.add<InstantPurchaseAcceptOrderResponse>(
      'InstantPurchase/accept-order',
      payload
    );
  }

  submitInstantPurchaseCounterOffer(
    payload: InstantPurchaseCounterOfferRequest
  ): Observable<InstantPurchaseCounterOfferResponse> {
    return this.dataService.add<InstantPurchaseCounterOfferResponse>(
      'InstantPurchase/counter-offer',
      payload
    );
  }

  getInstantPurchaseCounterOffer(
    payload: InstantPurchaseGetCounterOfferRequest
  ): Observable<InstantPurchaseGetCounterOfferResponse> {
    return this.dataService.add<InstantPurchaseGetCounterOfferResponse>(
      'InstantPurchase/counter-offer/get',
      payload
    );
  }

  checkInstantPurchaseRfqFeedback(
    payload: InstantPurchaseRfqFeedbackCheckRequest
  ): Observable<InstantPurchaseRfqFeedbackCheckResponse> {
    return this.dataService.add<InstantPurchaseRfqFeedbackCheckResponse>(
      'InstantPurchase/feedback/check',
      payload
    );
  }

  submitInstantPurchaseRfqFeedback(
    payload: InstantPurchaseRfqFeedbackSaveRequest
  ): Observable<InstantPurchaseRfqFeedbackSaveResponse> {
    return this.dataService.add<InstantPurchaseRfqFeedbackSaveResponse>(
      'InstantPurchase/feedback/save',
      payload
    );
  }

  getSupplierDynamicTilesIntentScoring(
    companyId: number
  ): Observable<SupplierDynamicTilesIntentScoringResponse> {
    return this.dataService.getAll<SupplierDynamicTilesIntentScoringResponse>(
      'Supplier/GetSupplierDynamicTilesIntentScoring?companyId=' + companyId,
      ''
    );
  }

  /**
   * Fire-and-forget: records a tile CTA click for personalization analytics.
   * Does not block UI; failures are logged only.
   */
  postSupplierDashboardTileCtaClick(payload: SupplierDashboardTileCtaClickRequest): void {
    this.http.post(this.userPersonalizationTilesUrl('cta-click'), payload).subscribe({
      error: (err) => console.warn('POST /api/v1/tiles/cta-click failed', err)
    });
  }

  getSupplierDashboardTileFeed(payload: unknown): Observable<SupplierDashboardTileFeedResponse> {
    return this.http.post<SupplierDashboardTileFeedResponse>(
      this.userPersonalizationTilesUrl('feed'),
      payload
    );
  }

  getSupplierDashboardTileHistory(payload: unknown): Observable<SupplierDashboardTileHistoryResponse> {
    return this.http.post<SupplierDashboardTileHistoryResponse>(
      this.userPersonalizationTilesUrl('history'),
      payload
    );
  }

  private userPersonalizationTilesUrl(path: 'feed' | 'history' | 'cta-click'): string {
    const base =
      (environment as { userPersonalizationApiUrl?: string }).userPersonalizationApiUrl ||
      'https://user-personalization.qa.mfg.com';
    const normalized = String(base).replace(/\/$/, '');
    return `${normalized}/api/v1/tiles/${path}`;
  }
}
